<template>
    <v-dialog
        ref="dialog"
        v-model="modal"
        persistent
        width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                v-model="innerValue"
                :label="label"
                readonly
                :prepend-inner-icon="prepand_icon"
                v-on="on"
                :rules="rules"
                flat
                solo
                prepend-icon="event"
                hide-details
                class="mb-0"
                :clearable="clearable"
            ></v-text-field>
        </template>
        <v-date-picker v-model="innerValue" scrollable>
            <v-spacer></v-spacer>
            <v-btn color="red lighten-1" class="white--text" @click="modal = false">Cancel</v-btn>
            <v-btn color="primary" @click="saveData">OK</v-btn>
        </v-date-picker>
    </v-dialog>

</template>

<script>

    export default {
        props: {
            rules: {
                type: [Object, Array, String],
                default: () => {
                    return [];
                },
            },
            label: {
                type: String,
                value: ''
            },
            prepand_icon: {
                type: String,
                value: ''
            },
            value: {
                type: null
            },
            clearable:{
                type: Boolean,
                default:false
            }
        },
        name: "FlatDatePicker",
        data() {
            return {
                modal: false,
                innerValue: null,

            }
        },
        methods: {
            saveData() {
                // this.$emit('input', this.innerValue);
                this.modal = false;
            }
        },
        watch: {
            innerValue(new_value) {
                this.$emit('input', new_value)
            },
            value(new_value) {
                this.innerValue = new_value
            }
        },
        created() {
            if (this.value) {
                this.innerValue = this.value;
            }
        }
    }
</script>
